import { NotifyHelper } from "../../../helpers/toast";
import { eCategoryComboActionTypeDefine } from "../../action-types/category/ICategoryComboActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const categoryComboActions = {
    ...generateActions(eCategoryComboActionTypeDefine, "CATEGORY_COMBO"),
    ...generateActionForKey(eCategoryComboActionTypeDefine, "CATEGORY_COMBO", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryComboActionTypeDefine, "CATEGORY_COMBO", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eCategoryComboActionTypeDefine, "CATEGORY_COMBO", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eCategoryComboActionTypeDefine, "CATEGORY_COMBO", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}

